// check whether element exists, then exec callback
$.fn.exists = function(callback) {
  if (this.length) {
    callback.call(this[0], this);
  }
  return this;
};

$.fn.existsEach = function(callback) {
  if (this.length) {
    this.each(function (i, element) {
      callback.call(this[0], $(element));
    })
  }
  return this;
};
